<template>
  <div class="policy">
    <menuBox :step="3"></menuBox>
    <div class="motto-box">
      <p class="bt">ให้บริการ</p>
    </div>
    <div class="strategy-box">
      <div class="bt">บริการเชิงกลยุทธ์</div>
      <div class="title">บริษัท วิมุต แฟมิลี่ จำกัด ตอบสนองความต้องการด้านการลงทุน การวางแผน
        และการบริหารความมั่งคั่งของคุณอย่างมืออาชีพ ผ่านบริการทางการเงินแบบครบวงจร </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/better1.png" alt="">
          <p>การจัดสรรสินทรัพย์</p>
          <span>ให้บริการลูกค้าด้วยกลยุทธ์การจัดสรรสินทรัพย์ที่ครอบคลุมเพื่อเพิ่มประสิทธิภาพพอร์ตการลงทุน</span>
        </div>
        <div class="item">
          <img src="../assets/better2.png" alt="">
          <p>แผนทางการเงิน</p>
          <span>ปรับแต่งการวางแผนทางการเงินสำหรับบุคคลและธุรกิจเพื่อช่วยเพิ่มความมั่งคั่ง</span>
        </div>
        <div class="item">
          <img src="../assets/better3.png" alt="">
          <p>วิเคราะห์การตลาด</p>
          <span>ให้ข้อมูลเชิงลึกเกี่ยวกับตลาดและการคาดการณ์แนวโน้มเพื่อเป็นแนวทางในการตัดสินใจลงทุน</span>
        </div>
      </div>
      <div class="lineBox">
        <div class="item">
          <img src="../assets/better4.png" alt="">
          <p>การบริหารความเสี่ยง</p>
          <span>ใช้เครื่องมือขั้นสูงเพื่อประเมินและควบคุมความเสี่ยงในการลงทุนเพื่อความปลอดภัยของสินทรัพย์</span>
        </div>
        <div class="item">
          <img src="../assets/better5.png" alt="">
          <p>ที่ปรึกษาการลงทุน</p>
          <span>ให้คำปรึกษาด้านการลงทุนจากผู้เชี่ยวชาญเพื่อช่วยให้บรรลุเป้าหมายทางการเงิน</span>
        </div>
        <div class="item">
          <img src="../assets/better6.png" alt="">
          <p>การวางแผนเกษียณอายุ</p>
          <span>ให้บริการวางแผนการเกษียณอายุแบบครบวงจรแก่บุคคลและครอบครัวเพื่อให้มั่นใจถึงอิสรภาพทางการเงินในอนาคต</span>
        </div>
      </div>
    </div>
    <div class="needHelp-box">
      <div class="left">
        <div class="title">
          ต้องการความช่วยเหลือ?
        </div>
        <div class="item">
          <img src="../assets/tel.png" alt="">
          <div>
            <p>+66 989041361</p>
            <span>Support Hotline</span>
          </div>
        </div>
        <div class="item">
          <img src="../assets/email.png" alt="">
          <div>
            <p>support@wimutfamily.com</p>
            <span>Support Email</span>
          </div>
        </div>
        <div class="support" @click="step">สนับสนุน →</div>
      </div>
      <div class="right">
        <div class="list" v-for="(item, key) in list" :key="key">
          <div class="top">
            <p> {{ item.title }}</p>
            <img v-if="!item.show" src="../assets/add.png" alt="" @click="item.show = !item.show">
            <img v-else src="../assets/close.png" alt="" @click="item.show = !item.show">
          </div>
          <div class="text" v-if="item.show">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {
      val: '',
      list: [
        {
          title: "จะเปิดบัญชีได้อย่างไร?",
          text: "คุณสามารถกรอกแบบฟอร์มใบสมัครออนไลน์ผ่านทางเว็บไซต์อย่างเป็นทางการของเรา หรือติดต่อศูนย์บริการลูกค้าของเราโดยตรงเพื่อขอคำแนะนำส่วนบุคคล",
          show: true
        },
        {
          title: "ผลิตภัณฑ์การลงทุนของบริษัทของคุณมีลักษณะอย่างไร?",
          text: "ผลิตภัณฑ์การลงทุนของเราครอบคลุมสินทรัพย์หลายประเภท โดยมุ่งเน้นที่ผลตอบแทนที่มั่นคงในระยะยาวและการควบคุมความเสี่ยงเพื่อตอบสนองความต้องการของลูกค้าที่แตกต่างกัน",
          show: false
        },
        {
          title: "ฉันจะติดตามพอร์ตโฟลิโอของฉันได้อย่างไร?",
          text: " ลูกค้าสามารถดูสถานะพอร์ตโฟลิโอของตนแบบเรียลไทม์ผ่านแพลตฟอร์มออนไลน์ของเรา และยังสามารถตั้งค่าตัวเลือกในการรับรายงานเป็นระยะได้",
          show: false
        },
        {
          title: "บริษัท ของคุณเรียกเก็บเงินอย่างไร?",
          text: "โครงสร้างค่าธรรมเนียมของเราประกอบด้วยค่าธรรมเนียมการจัดการและค่าธรรมเนียมการปฏิบัติงาน โดยมีรายละเอียดเฉพาะที่จะแตกต่างกันไปขึ้นอยู่กับผลิตภัณฑ์และบริการด้านการลงทุน",
          show: false
        },
        {
          title: "จะมั่นใจในความปลอดภัยของเงินทุนของฉันได้อย่างไร?",
          text: "เราใช้มาตรการรักษาความปลอดภัยชั้นนำของอุตสาหกรรมเพื่อปกป้องทรัพย์สินของลูกค้าในขณะที่ปฏิบัติตามกฎระเบียบและมาตรฐานของหน่วยงานกำกับดูแลอย่างเคร่งครัด",
          show: false
        }
      ]
    };
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "privacy" });
    },
  },
};
</script>
<style lang="less" scoped>
.policy {
  .motto-box {
    background-image: url(../assets/services.png);
    width: 100%;
    height: 500px;
    background-size: 100% 100%;
    padding: 180px 0 0 0;
    position: relative;
    box-sizing: border-box;

    .bt {
      text-align: center;
      margin-bottom: 35px;
      font-size: 58px;
      font-family: Roboto, Roboto;
      font-weight: 800;
      color: #FFFFFF;
    }
  }
}

.strategy-box {
  padding: 145px 310px 0;
  box-sizing: border-box;

  .bt {
    margin-bottom: 10px;
    text-align: center;
    font-size: 40px;
    font-family: Roboto, Roboto;
    font-weight: bold;
    color: #252B42;
    line-height: 57px;
  }

  .title {
    margin-bottom: 80px;
    text-align: center;
    font-size: 14px;
    font-family: Roboto, Roboto;
    font-weight: 400;
    color: #737373;
    line-height: 20px;
  }

  .lineBox {
    display: flex;

    .item {
      width: 33%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: 0 38px 40px 0;
      padding: 22px 70px;
      box-sizing: border-box;
      box-shadow: 0px 8px 32px 0px rgba(48, 104, 156, 0.1);

      img {
        margin-bottom: 20px;
        width: 42px;
        height: 42px;
      }

      p {
        margin-bottom: 14px;
        font-size: 24px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: #252B42;
        line-height: 40px
      }

      span {
        font-size: 18px;
        font-family: Roboto, Roboto;
        font-weight: 400;
        color: rgba(37, 43, 66, 0.6);
        line-height: 24px;
      }
    }

    .item:nth-child(3n) {
      margin-right: 0;
    }
  }
}

.needHelp-box {
  padding: 160px 310px 120px;
  display: flex;
  justify-content: space-between;

  .left {
    .title {
      margin-bottom: 53px;
      font-size: 54px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #1A191E;
    }

    .item {
      display: flex;
      margin-bottom: 37px;
      overflow: hidden;

      img {
        margin-right: 26px;
        width: 53px;
        height: 53px;
      }

      p {
        margin-bottom: 10px;
        font-size: 20px;
        font-family: DM Sans, DM Sans;
        font-weight: 500;
        color: #1A191E;
      }

      span {
        font-size: 15px;
        font-family: Inter, Inter;
        font-weight: 500;
        color: rgba(26, 25, 30, 0.5);
      }
    }

    .support {
      cursor: pointer;
      margin-top: 20px;
      font-size: 20px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      color: #00387A;
      overflow: hidden;
    }
  }

  .right {
    .list {
      width: 650px;
      padding: 35px 0;
      border-bottom: 1px solid #E8E8E8;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          cursor: pointer;
          width: 26px;
          height: 26px;
        }

        p {
          font-size: 22px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #1A191E;
        }
      }

      .text {
        margin-top: 18px;
        font-size: 17px;
        font-family: Roboto, Roboto;
        font-weight: 500;
        color: rgba(26, 25, 30, 0.5);
        line-height: 27px;
      }
    }
  }
}
</style>
